const language: any = {
  english: {
    password: "Password",
    confirmPAssword: "Confirm password",
    email: "Email",
    organization: "Organization",
    login: "Login",
    register: "Register",
    registerAccount: "Register account",
    forgotPassword: "Forgot password?",
    forgotPasswordDescription:
      "Enter your email address and we will send you a link to reset your password.",
    resetPassword: "Reset password",
    next: "Next",
    required: "Field is Required",
    invalidEmail: "Invalid Email",
    invalidPhoneNumber: "Invalid Phone number",
    phoneNumber: "Phone number",
    confirmPassword: "Confirm Password",
    userData: "User Data",
    companyData: "Company Data",
    delegate: "Delegate",
    contract: "Contract",
    documents: "Documents",
    back: "Back",
    address: "Address",
    CIF: "CIF",
    IBAN: "IBAN",
    bank: "Bank",
    nrRegCom: "Nr. Reg. Com.",
    firstName: "First Name",
    lastName: "Last Name",
    nrContract: "Nr. Contract",
    nrProforma: "Nr. Proforma",
    serieContract: "Serie Contract",
    serieProforma: "Serie Proforma",
    CNP: "CNP",
    series: "Series",
    nr: "Nr.",
    invalidCNP: "Invalid CNP",
    dashboard: "Dashboard",
    companies: "Companies",
    users: "Users",
    createdAt: "Created At",
    CUI: "CUI",
    suspendAccount: "Suspend Account",
    suspendAccountDescription: "Are you sure you want to suspend this account?",
    successfullyDeleted: "Deleted successfully",
    successfullyAdded: "Saved successfully",
    successfullyUpdated: "Updated successfully",
    deleteError: "Error while deleting",
    addError: "Error while saving",
    updateError: "Error while updating",
    unsuspendAccount: "Unsuspend Account",
    suspendedAccount: "Account Suspended",
    activeAccount: "Account Active",
    unsuspendAccountDescription:
      "Are you sure you want to unsuspend this account?",
    addNewUser: "Add New User",
    username: "Username",
    invalidCompanyName: "Invalid company name",
  },
  romanian: {
    password: "Parola",
    confirmPAssword: "Confirma parola",
    email: "E-mail",
    organization: "Organizatia",
    login: "Autentificare",
    register: "Inregistrare",
    location: "Locatie administrativa",
    registerAccount: "Creare cont",
    forgotPassword: "Am uitat parola?",
    forgotPasswordDescription:
      "Introduceți adresa de e-mail și vom trimite un link de resetare a parolei.",
    next: "Următorul",
    required: "Campul este obligatoriu",
    invalidEmail: "E-mail invalid",
    invalidPhoneNumber: "Număr de telefon invalid",
    phoneNumber: "Număr de telefon",
    confirmPassword: "Confirma parola",
    userData: "Date utilizator",
    companyData: "Date companie",
    delegate: "Delegat",
    contract: "Contract",
    documents: "Documente",
    back: "Înapoi",
    address: "Adresa",
    CIF: "CIF",
    IBAN: "IBAN",
    bank: "Banca",
    nrRegCom: "Nr. Reg. Com.",
    firstName: "Prenume",
    lastName: "Nume",
    nrContract: "Nr. Contract",
    nrProforma: "Nr. Proforma",
    serieContract: "Serie Contract",
    serieProforma: "Serie Proforma",
    CNP: "CNP",
    series: "Serie",
    nr: "Nr.",
    invalidCNP: "CNP invalid",
    dashboard: "Dashboard",
    companies: "Companies",
    users: "Users",
    createAt: "Creat la",
    CUI: "CUI",
    suspendAccount: "Suspendare cont",
    suspendAccountDescription: "Sigur doriți să suspendați acest cont ?",
    unsuspendAccountDescription: "Sigur doriți să activați acest cont ?",
    successfullyDeleted: "Șters cu succes",
    successfullyAdded: "Salvat cu succes",
    successfullyUpdated: "Actualizat cu succes",
    deleteError: "Eroare la ștergere",
    addError: "Eroare la salvare",
    updateError: "Eroare la actualizare",
    unsuspendAccount: "Activare cont",
    suspendedAccount: "Cont suspendat",
    activeAccount: "Cont activ",
    deleteUser: "Sterge utilizatorul",
    deleteUserMessage: "Doriti sa stergeti acest utilizator ?",
    addNewUser: "Adauga utilizator",
    username: "Nume utilizator",
    invalidCompanyName:
      "Numele companiei trebuie sa contina doar litere si numere.",
    locationName: "Nume locatie administrativa",
    county: "Judet",
    accessDenied: "Acces interzis",
    accessDeniedDescription: "Aceasta pagina poate fi accesata doar din aplicatia ERP.",
  },
};

const userLang = localStorage.getItem("language") || "romanian";

const lang = language[userLang];

export { lang };
